<script setup lang="ts">
import {storeToRefs} from "pinia";
import {useInterfaceStore} from "~/stores/interface";
import {useSnackbarStore} from "~/stores/SnackbarStore";

const {showPreferredChannelsOnly} = storeToRefs(useInterfaceStore())
const {t} = useI18n()
const snackbar = useSnackbarStore()

watch(showPreferredChannelsOnly, async (newValue) => {
  if (newValue) {
    try {
      const pilotTeamSettings = await useApi().getPilotTeamSettings()
      if (!pilotTeamSettings.preferredChannels.length) {
        showPreferredChannelsOnly.value = false
        snackbar.showErrorSnackbar(t('channelsNotSelectedError'))
      }
    } catch (e) {
      console.error(e)
    }
  }
})

</script>

<template>
  <v-switch
      v-model="showPreferredChannelsOnly"
      :label="t('label')"
      :hide-details="true"
  />
</template>

<i18n>
{
  "uk": {
    "label": "Лише мої канали",
    "channelsNotSelectedError": "Неможливо увімкнути цю опцію: у налаштуваннях екіпажу не вибрано жодного каналу."
  },
  "en": {
    "label": "Only my channels",
    "channelsNotSelectedError": "This option cannot be enabled: no channels have been selected in the crew settings."
  }
}
</i18n>
